import React, { useMemo, useState } from 'react';
import { Box, ModalClose } from '@mui/joy';
import { List as ListComponent, BreadCrumb, DetailTitle, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks';
import { useTranslation } from 'react-i18next';

const dataProviderName = 'queues/job';

const Log = (params) => {
    const { t } = useTranslation();
    const { activate } = useDrawer();
    const { model, entityId, title } = params;

    const { loadAll, items, total, loading, reloadCounter, getOne } = useDataProvider(dataProviderName);
    const [listFilterPageSort, setListFilterPageSort] = useState();

    const loadParams = useMemo(() => ({
        ...params,
        otherFilters: model && entityId ? { model, entity_id: entityId } : {},
    }), [params, model, entityId]);

    useLoadAll({ listFilterPageSort, loadAll, params: loadParams, reloadCounter });

    const handleFilterPageSortChange = (model) => {
        setListFilterPageSort(model);
    };

    const handleRowDoubleClick = (row) => {
        const id = row?.id ?? row?._id;
        const record = getOne(id) ?? items?.find((item) => (item?.id ?? item?._id) === id);
        activate('wizards/logData', {
            data: record?.data,
            action: record?.action,
            subtitle: record?.action,
            detailStack: params.detailStack,
        });
    };

    return (
        <>
            {params.isDrawer && (
                <Box className="drawer-section-header">
                    <ModalClose />
                    <DetailTitle
                        title={t('Log')}
                        subtitle={title ? `${title}` : `${model} / ${entityId}`}
                    />
                </Box>
            )}
            <BreadCrumb />
            {model && entityId ? (
                <ListComponent
                    {...params}
                    dataProviderName={dataProviderName}
                    isDrawer
                    items={items}
                    total={total}
                    loading={loading}
                    onFilterPageSortChange={handleFilterPageSortChange}
                    onRowDoubleClick={handleRowDoubleClick}
                    removeSaveButton
                    hideTableToolbar={false}
                />
            ) : (
                <Box className="drawer-section-content drawer-section-content-embedded form-element col-12">
                    {t('Missing entity context for log')}
                </Box>
            )}
        </>
    );
};

export default Log;
